// extracted by mini-css-extract-plugin
module.exports = {"pintxo-badge-wrapper":"BadgeWrapper_pintxo-badge-wrapper__sF5p8","pintxo-badge-wrapper__badge":"BadgeWrapper_pintxo-badge-wrapper__badge___tw8n"};